// Runtime config from env-config.js (injected at container startup),
// with fallback to process.env for local CRA dev server.
const env = (key) =>
  (window.__ENV__ && window.__ENV__[key]) || process.env[key];

const config = {
  COGNITO_REGION: env('REACT_APP_COGNITO_REGION'),
  COGNITO_USERPOOL_ID: env('REACT_APP_COGNITO_USERPOOL_ID'),
  COGNITO_CLIENT_ID: env('REACT_APP_COGNITO_CLIENT_ID'),
  COGNITO_DOMAIN: env('REACT_APP_COGNITO_DOMAIN'),
  // Optional custom Cognito service endpoint (local mock-aws). Unset in prod -> real Cognito.
  COGNITO_ENDPOINT: env('REACT_APP_COGNITO_ENDPOINT'),
  COGNITO_REDIRECT_URL: env('REACT_APP_COGNITO_REDIRECT_URL'),
  FALLBACK_CALLBACK: env('REACT_APP_FALLBACK_CALLBACK'),
  LOG_LEVEL: env('REACT_APP_LOG_LEVEL'),
};

export default config;
